export function GoogleIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>G o o g l e</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.04 12.26C23.04 11.45 22.97 10.66 22.83 9.91H12V14.36H18.19C17.92 15.795 17.11 17.013 15.89 17.83V20.71H19.61C21.79 18.71 23.04 15.76 23.04 12.26Z"
        fill="#4285F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 23.5C15.105 23.5 17.71 22.47 19.61 20.71L15.89 17.83C14.86 18.52 13.55 18.926 12 18.926C9 18.926 6.47 16.903 5.57 14.18H1.72V17.16C3.62 20.92 7.5 23.5 12 23.5Z"
        fill="#34A853"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.57 14.19C5.34 13.5 5.2 12.758 5.2 12C5.2 11.24 5.34 10.51 5.57 9.82V6.84H1.72C0.94 8.39 0.5 10.14 0.5 12C0.5 13.86 0.94 15.61 1.72 17.16L5.57 14.19Z"
        fill="#FBBC05"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 5.07C13.69 5.07 15.2 5.65 16.4 6.79L19.69 3.5C17.7 1.64 15.1 0.5 12 0.5C7.5 0.5 3.62 3.08 1.72 6.84L5.57 9.815C6.47 7.1 9 5.07 12 5.07Z"
        fill="#EA4335"
      />
    </svg>
  );
}
